import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Toaster } from 'react-hot-toast';

import { AuthProvider }      from './context/AuthContext';
import ProtectedRoute        from './components/auth/ProtectedRoute';
import Navbar                from './components/layout/Navbar';
import Footer                from './components/layout/Footer';

import LoginPage             from './pages/LoginPage';
import FeedbackPage          from './pages/FeedbackPage';
import DashboardPage         from './pages/admin/DashboardPage';
import DepartmentsPage       from './pages/admin/DepartmentsPage';
import AuditPage             from './pages/admin/AuditPage';
import AuthorizedUsersPage   from './pages/admin/AuthorizedUsersPage';

import './index.css';

function Unauthorized() {
  return (
    <div style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column',
                  alignItems: 'center', justifyContent: 'center', gap: 12 }}>
      <span style={{ fontSize: '3rem' }}>🚫</span>
      <h2 style={{ color: 'var(--primary)' }}>Access Denied</h2>
      <p className="text-muted">You don't have permission to view this page.</p>
    </div>
  );
}

export default function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <BrowserRouter>
          <div className="app-layout">
            <Navbar />
            <main className="app-main">
              <Routes>
                <Route path="/login"        element={<LoginPage />} />
                <Route path="/unauthorized" element={<Unauthorized />} />

                {/* Regular users only */}
                <Route path="/feedback" element={
                  <ProtectedRoute userOnly><FeedbackPage /></ProtectedRoute>
                } />

                {/* Dashboard: admin_editor, admin_viewer, aboutu */}
                <Route path="/admin/dashboard" element={
                  <ProtectedRoute dashboardOnly><DashboardPage /></ProtectedRoute>
                } />

                {/* Admin only (not aboutu) */}
                <Route path="/admin/authorized-users" element={
                  <ProtectedRoute adminOnly><AuthorizedUsersPage /></ProtectedRoute>
                } />
                <Route path="/admin/departments" element={
                  <ProtectedRoute adminOnly><DepartmentsPage /></ProtectedRoute>
                } />
                <Route path="/admin/audit" element={
                  <ProtectedRoute adminOnly><AuditPage /></ProtectedRoute>
                } />

                <Route path="/"  element={<Navigate to="/feedback" replace />} />
                <Route path="*"  element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </BrowserRouter>

        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              fontFamily: 'DM Sans, Helvetica, Arial, sans-serif',
              fontSize: '0.9rem',
              borderRadius: '10px',
              boxShadow: '0 4px 20px rgba(33,29,112,0.15)',
            },
            success: { iconTheme: { primary: '#22c55e', secondary: '#fff' } },
            error:   { iconTheme: { primary: '#ED1C24', secondary: '#fff' } },
          }}
        />
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}
